import { ChildAccountType } from "@prisma/client-generated";
import { z } from "zod";

export const childAccountSchemaCreate = z.object({
  childName: z.string().nullish(),
  description: z.string().nullish(),
  institution: z.string().nullish(),
  accountNumber: z.string().max(4).nullish(),
  currency: z.string().nullish(),
  valueInCents: z.number().min(0),
  childAccountType: z.nativeEnum(ChildAccountType).nullish(),
});

export const childAccountSchemaUpdate = childAccountSchemaCreate.partial();

export type ChildAccountUpsertData = z.infer<
  typeof childAccountSchemaUpdate
> & { id?: string | undefined };
